"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueSources = void 0;

var _Accumulator = require("./Accumulator");

var _Boolean = require("./Boolean");

var _ComponentByPath = require("./ComponentByPath");

var _ComponentRowByPath = require("./ComponentRowByPath");

var _ComponentRowIndexByPath = require("./ComponentRowIndexByPath");

var _ComponentValueByPath = require("./ComponentValueByPath");

var _Condition = require("./Condition");

var _ConditionalAssignment = require("./ConditionalAssignment");

var _CurrentDateTime = require("./CurrentDateTime");

var _Date = require("./Date");

var _DateTime = require("./DateTime");

var _Form = require("./Form");

var _FormData = require("./FormData");

var _Item = require("./Item");

var _ItemIndex = require("./ItemIndex");

var _List = require("./List");

var _Number = require("./Number");

var _ParentItemIndexes = require("./ParentItemIndexes");

var _ParentItems = require("./ParentItems");

var _RegExp = require("./RegExp");

var _SourceComponent = require("./SourceComponent");

var _SourceComponentRow = require("./SourceComponentRow");

var _SourceComponentRowIndex = require("./SourceComponentRowIndex");

var _SourceComponentValue = require("./SourceComponentValue");

var _String = require("./String");

var _ThisComponent = require("./ThisComponent");

var _ThisComponentRow = require("./ThisComponentRow");

var _ThisComponentRowIndex = require("./ThisComponentRowIndex");

var _ThisComponentValue = require("./ThisComponentValue");

var _Time = require("./Time");

var _Variable = require("./Variable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var valueSources = [_Accumulator.AccumulatorValueSource, _Boolean.BooleanValueSource, _ComponentByPath.ComponentByPathValueSource, _ComponentRowByPath.ComponentRowByPathValueSource, _ComponentRowIndexByPath.ComponentRowIndexByPathValueSource, _ComponentValueByPath.ComponentValueByPathValueSource, _Condition.ConditionValueSource, _ConditionalAssignment.ConditionalAssignmentValueSource, _CurrentDateTime.CurrentDateTimeValueSource, _Date.DateValueSource, _DateTime.DateTimeValueSource, _Form.FormValueSource, _FormData.FormDataValueSource, _Item.ItemValueSource, _ItemIndex.ItemIndexValueSource, _List.ListValueSource, _Number.NumberValueSource, _ParentItemIndexes.ParentItemIndexesValueSource, _ParentItems.ParentItemsValueSource, _RegExp.RegExpValueSource, _SourceComponent.SourceComponentValueSource, _SourceComponentRow.SourceComponentRowValueSource, _SourceComponentRowIndex.SourceComponentRowIndexValueSource, _SourceComponentValue.SourceComponentValueValueSource, _String.StringValueSource, _ThisComponent.ThisComponentValueSource, _ThisComponentRow.ThisComponentRowValueSource, _ThisComponentRowIndex.ThisComponentRowIndexValueSource, _ThisComponentValue.ThisComponentValueValueSource, _Time.TimeValueSource, _Variable.VariableValueSource].reduce(function (result, valueSource) {
  return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, valueSource.name, valueSource));
}, {});

var ValueSources = /*#__PURE__*/function () {
  function ValueSources() {
    _classCallCheck(this, ValueSources);
  }

  _createClass(ValueSources, null, [{
    key: "addValueSource",
    value: function addValueSource(name, valueSource) {
      ValueSources.valueSources[name] = valueSource;
    }
  }, {
    key: "addValueSources",
    value: function addValueSources(valueSources) {
      ValueSources.valueSources = _objectSpread(_objectSpread({}, ValueSources.valueSources), valueSources);
    }
  }, {
    key: "getValueSource",
    value: function getValueSource(name) {
      return ValueSources.valueSources[name];
    }
  }, {
    key: "getValueSources",
    value: function getValueSources() {
      return ValueSources.valueSources;
    }
  }]);

  return ValueSources;
}();

exports.ValueSources = ValueSources;

_defineProperty(ValueSources, "valueSources", valueSources);